import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import './TestimonialSection.css';

const testimonials = [
  {
    rating: 5,
    text: "Relax helps me sleep faster and feel peaceful after stressful days.",
    author: "Sarah J."
  },
  {
    rating: 5,
    text: "A must-have app for anyone needing focus and calm. I use it every day at work.",
    author: "Michael T."
  },
  {
    rating: 5,
    text: "The sleep sounds are incredible. I've never felt more rested.",
    author: "Emily R."
  }
];

const TestimonialSection = () => {
  return (
    <section id="testimonials" className="section-padding testimonials-section">
      <div className="container">
        <motion.div 
          className="section-header text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Loved by <span className="text-primary">Thousands</span></h2>
          <p>See what our users have to say about their experience.</p>
        </motion.div>

        <div className="testimonials-grid">
          {testimonials.map((item, index) => (
            <motion.div 
              key={index} 
              className="testimonial-card"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
            >
              <div className="stars">
                {[...Array(item.rating)].map((_, i) => (
                  <Star key={i} size={20} fill="var(--primary)" color="var(--primary)" />
                ))}
              </div>
              <p className="testimonial-text">"{item.text}"</p>
              <h4 className="testimonial-author">- {item.author}</h4>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
